import { MONTHS_RU, MONTHS_SHORT_RU } from "./constants.js";

/* Деньги. ТЗ 11: рубль, разделители тысяч. */
export const rub = (n) => new Intl.NumberFormat("ru-RU").format(Math.round(n || 0)) + " ₽";

export const rubK = (n) => {
  const v = n || 0;
  if (Math.abs(v) >= 1_000_000) return (v / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + " млн ₽";
  if (Math.abs(v) >= 1000) return Math.round(v / 1000) + "к ₽";
  return v + " ₽";
};

/** Компактно и без валюты: 1.25 млн, 200 т, 4 500.
    Для тесных мест, где рубль и разряды не помещаются — вроде лестницы целей. */
export const shortNum = (n) => {
  const v = Math.round(n || 0);
  if (Math.abs(v) >= 1_000_000) return (v / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + " млн";
  if (Math.abs(v) >= 10_000) return Math.round(v / 1000) + " т";
  return new Intl.NumberFormat("ru-RU").format(v);
};

export const pct = (a, b) => (!b ? 0 : Math.max(0, Math.min(100, (a / b) * 100)));
export const marginPct = (profit, revenue) => (!revenue ? 0 : Math.round((profit / revenue) * 100));

/* ── Даты ───────────────────────────────────────────────────
   В БД — полноценные даты (ISO 'YYYY-MM-DD'). В UI — ДД.ММ (ТЗ 11).
   Работаем со строками, чтобы не ловить сдвиг часового пояса. */

export const toISO = (d) => {
  if (!d) return null;
  if (typeof d === "string") return d.slice(0, 10);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/** 'YYYY-MM-DD' → 'ДД.ММ' */
export const ddmm = (iso) => {
  const s = toISO(iso);
  return s ? `${s.slice(8, 10)}.${s.slice(5, 7)}` : "—";
};

/** 'YYYY-MM-DD' → '15 июля' */
const GEN = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
export const humanDate = (iso) => {
  const s = toISO(iso);
  if (!s) return "—";
  return `${Number(s.slice(8, 10))} ${GEN[Number(s.slice(5, 7)) - 1]}`;
};

/** 'ДД.ММ' (+ год) → 'YYYY-MM-DD'. Для парсинга ввода из бота и старых данных. */
export const fromDDMM = (s, year = new Date().getFullYear()) => {
  const m = /^(\d{1,2})[.\/](\d{1,2})$/.exec(String(s || "").trim());
  if (!m) return null;
  const p = (n) => String(n).padStart(2, "0");
  return `${year}-${p(m[2])}-${p(m[1])}`;
};

export const monthKey = (iso) => toISO(iso)?.slice(0, 7) || null; // 'YYYY-MM'
export const monthLabel = (key) => MONTHS_RU[Number(key.slice(5, 7)) - 1];
export const monthShort = (key) => MONTHS_SHORT_RU[Number(key.slice(5, 7)) - 1];

/** Разница в днях между двумя ISO-датами (b − a). */
export const daysBetween = (a, b) => {
  const A = Date.parse(toISO(a) + "T00:00:00Z");
  const B = Date.parse(toISO(b) + "T00:00:00Z");
  if (Number.isNaN(A) || Number.isNaN(B)) return null;
  return Math.round((B - A) / 86_400_000);
};

export const addDays = (iso, n) => {
  const t = Date.parse(toISO(iso) + "T00:00:00Z") + n * 86_400_000;
  return new Date(t).toISOString().slice(0, 10);
};

/** Склонение: 3 дн. / 1 день */
/** 'YYYY-MM-DD' → '01.01.2026' */
export const dmy = (iso) => {
  const s = toISO(iso);
  return s ? `${s.slice(8, 10)}.${s.slice(5, 7)}.${s.slice(0, 4)}` : "—";
};

export const plural = (n, one, few, many) => {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b > 1 && b < 5) return few;
  if (b === 1) return one;
  return many;
};
export const daysWord = (n) => plural(n, "день", "дня", "дней");
